import Fetch from './fetch';
import HttpUtils from './http-utils';
import FetchPromise from './fetch-promise';

// TODO: imo we should break this up to internal/external
const AcademiesApi = {
  analytics: {
    filteredAssignments: (id, queryParams, successHandler, errorHandler) => {
      const uri = HttpUtils.buildUriWithQueryString(`academies/${id}/analytics/filtered_assignments`, queryParams);

      return Fetch.get(uri, null, successHandler, errorHandler);
    },
    externalUsers: ({ academyId, queryParams, onSuccess = null, onError = null }) =>
      Fetch.get(
        HttpUtils.buildUriWithQueryString(`academies/${academyId}/analytics/external_users`, queryParams),
        null,
        onSuccess,
        onError,
      ),
    academyCertificationUsers: ({ academyId, queryParams }) =>
      Fetch.get(
        HttpUtils.buildUriWithQueryString(`academies/${academyId}/analytics/academy_certification_users`, queryParams),
      ),
    exportCSV: ({ academyId, queryParams, onSuccess, onError }) =>
      Fetch.get(
        HttpUtils.buildUriWithQueryString(`academies/${academyId}/analytics/export_csv`, queryParams),
        null,
        onSuccess,
        onError,
      ),
  },
  internal: {
    updateIsCorrect: (id, data, successCb, errorCb) =>
      Fetch.put(`answer_submission/${id}/update_is_correct`, data, successCb, errorCb),
    getAssignments: (id, queryParams, successHandler, errorHandler) => {
      const uri = HttpUtils.buildUriWithQueryString(`academies/${id}/assignments`, queryParams);

      return Fetch.get(uri, null, successHandler, errorHandler);
    },
    getAcademyCertificationUsers: (id, queryParams, onSuccess, onError) => {
      const uri = HttpUtils.buildUriWithQueryString(
        `academy_certifications/${id}/academy_certification_users`,
        queryParams,
      );
      return Fetch.get(uri, null, onSuccess, onError);
    },
  },
  getNextModuleInCertOrPath: (certOrPathId, guideId) =>
    Fetch.get(`academy_certifications/${certOrPathId}/next/${guideId}`),
  bulkEnroll: (academyId, data, onSuccess, onError) =>
    Fetch.postV2(`academies/${academyId}/bulk_assign_training`, data, onSuccess, onError),
  delete: (id) => Fetch.delete(`academies/${id}`),
  deleteCertification: (certificationId) => Fetch.delete(`academy_certifications/${certificationId}`),
  deleteCollection: (collectionId) => Fetch.delete(`academy_collections/${collectionId}`),
  deleteCertificationContent: (certificationId, contentId) =>
    Fetch.delete(`academy_certifications/${certificationId}/content/${contentId}`),
  deleteContent: (collectionId, contentId) => Fetch.delete(`academy_collections/${collectionId}/content/${contentId}`),
  deleteEvent: (eventId) => Fetch.delete(`academy_events/${eventId}`),
  deleteEventSession: (eventSessionId) => Fetch.delete(`academy_event_sessions/${eventSessionId}`),
  deleteEventOnDemandContent: (eventOnDemandContentId) =>
    Fetch.delete(`academy_event_on_demand_contents/${eventOnDemandContentId}`),
  deleteRegistrationField: (registrationFieldId) => Fetch.delete(`academy_registration_fields/${registrationFieldId}`),
  deleteStripeConnectedAccount: (academyId) => Fetch.delete(`academies/${academyId}/delete_stripe_connected_account`),
  updateStripeTaxEnabled: (academyId, data) => Fetch.put(`academies/${academyId}`, { stripe_tax_enabled: data }),
  fetchNumUsers: (academyId) => Fetch.get(`academies/${academyId}/num_users`),
  fetchOauthSecret: (academyId) => Fetch.get(`academies/${academyId}/oauth_secret`),
  fetchUserAwardedCertifications: (externalUserId) => Fetch.get(`academy_certifications/user/${externalUserId}`),
  fetchUserAwardedCertificationInfo: (academyCertificationUserId) =>
    Fetch.get(`awarded_certificate_info/${academyCertificationUserId}`),
  fetchActiveRegistrationFields: ({ academyId, withPromise, successCb, errCb }) => {
    const fetch = withPromise ? FetchPromise.get : Fetch.get;
    return fetch(`academy_registration_fields/${academyId}`, null, successCb, errCb);
  },
  fetchUpdatedAcademyCertificationUserAssignments: (academyCertificationUserId, assignments) =>
    Fetch.post(`academy_certification_users/${academyCertificationUserId}/updated_assignments`, { assignments }),
  new: (academyParams) => Fetch.post('academies', academyParams),
  newCertification: (academyId, certificationParams) =>
    Fetch.post(`academies/${academyId}/certifications`, { certification: certificationParams }),
  newCertificationContents: (certificationId, contentParams) =>
    Fetch.post(`academy_certifications/${certificationId}`, { content: contentParams }),
  newCollection: (academyId, collectionParams) =>
    Fetch.post(`academies/${academyId}/collections`, { collection: collectionParams }),
  newCollectionContents: (collectionId, contentParams) =>
    Fetch.post(`academy_collections/${collectionId}`, { content: contentParams }),
  newEvent: (academyId, eventParams) => Fetch.post(`academies/${academyId}/events`, { event: eventParams }),
  newEventSession: (eventId, eventSessionParams) =>
    Fetch.post(`academy_events/${eventId}/academy_event_sessions`, { eventSession: eventSessionParams }),
  newEventOnDemandContent: (eventId, eventOnDemandContentParams) =>
    Fetch.post(`academy_events/${eventId}/academy_event_on_demand_contents`, {
      eventOnDemandContent: eventOnDemandContentParams,
    }),
  newRegistrationField: (registrationFieldParams) => Fetch.post('academy_registration_fields', registrationFieldParams),
  newRegistrationFieldValue: (registrationFieldValueParams) =>
    Fetch.post('academy_registration_field_values', registrationFieldValueParams),
  reorderCertification: (academyId, sortedCertificationIds) =>
    Fetch.put(`academies/${academyId}/certifications/reorder`, { sortedCertificationIds }),
  reorderPath: (academyId, sortedPathIds) => Fetch.put(`academies/${academyId}/paths/reorder`, { sortedPathIds }),
  reorderCertificationContent: (certificationId, sortedContentParams) =>
    Fetch.put(`academy_certifications/${certificationId}/content/reorder`, {
      sortedContentParams,
    }),
  reorderCollection: (academyId, sortedCollectionIds) =>
    Fetch.put(`academies/${academyId}/collections/reorder`, { sortedCollectionIds }),
  reorderContent: (collectionId, sortedContentIds) =>
    Fetch.put(`academy_collections/${collectionId}/content/reorder`, { sortedContentIds }),
  reorderCustomRegistrationField: (academyId, sortedAcademyRegistrationFieldIds) =>
    Fetch.put(`academies/${academyId}/custom_registration_fields_order`, {
      sorted_academy_registration_field_ids: sortedAcademyRegistrationFieldIds,
    }),
  reorderEvent: (academyId, sortedEventIds) => Fetch.put(`academies/${academyId}/events/reorder`, { sortedEventIds }),
  requestPasswordResetToken: (resetTokenParams) => Fetch.post('forgot_password', resetTokenParams),
  submitNewPassword: (resetParams) => Fetch.put('reset_password', resetParams),
  submitResponse: (assignmentId, contentId, response, successCb, errorCb) =>
    Fetch.postV2(`save_answer/${assignmentId}/${contentId}`, response, successCb, errorCb),
  update: (id, academyParams) => Fetch.put(`academies/${id}`, academyParams),
  updateCertification: (certificationId, certificationParams) =>
    Fetch.put(`academy_certifications/${certificationId}`, certificationParams),
  updateCollection: (collectionId, collectionParams) =>
    Fetch.put(`academy_collections/${collectionId}`, collectionParams),
  updateEvent: (eventId, eventParams) => Fetch.put(`academy_events/${eventId}`, eventParams),
  updateEventSession: (sessionId, eventSessionParams) =>
    Fetch.put(`academy_event_sessions/${sessionId}`, { eventSession: eventSessionParams }),
  updateEventOnDemandContent: (onDemandContentId, eventOnDemandContentParams) =>
    Fetch.put(`academy_event_on_demand_contents/${onDemandContentId}`, {
      eventOnDemandContent: eventOnDemandContentParams,
    }),
  updateAcademyCertificationUser: (academyCertUserId, updateParams) =>
    Fetch.put(`academy_certification_users/${academyCertUserId}`, updateParams),
  updateAcademyCertificationUserSeenAward: (academyCertUserId, updateParams) =>
    Fetch.put(`academy_certification_users/seen_award/${academyCertUserId}`, updateParams),
  updateAcademyCertificationUserSeenCompletedAndRequiresGrading: (
    academyCertUserId,
    updateParams,
    successCb,
    errorCb,
  ) =>
    Fetch.put(
      `academy_certification_users/seen_completed_and_requires_grading/${academyCertUserId}`,
      updateParams,
      successCb,
      errorCb,
    ),
  deleteCertificationUser: (certificationUserId, payload = null, onSuccess, onError) =>
    Fetch.delete(`academy_certification_users/${certificationUserId}`, payload, onSuccess, onError),
  updateContent: (collectionId, contentId, contentParams) =>
    Fetch.put(`academy_collections/${collectionId}/content/${contentId}`, contentParams),
  updateExternalUser: (externalUserId, externalUserParams) =>
    Fetch.put(`external_users/${externalUserId}`, externalUserParams),
  updateRegistrationField: (registrationFieldId, registrationFieldParams) =>
    Fetch.put(`academy_registration_fields/${registrationFieldId}`, registrationFieldParams),
  updateRegistrationFieldValue: (registrationFieldValueId, registrationFieldValueParams) =>
    Fetch.put(`academy_registration_field_values/${registrationFieldValueId}`, registrationFieldValueParams),
  deleteCustomFontFile: (academyId) => FetchPromise.delete(`academies/${academyId}/custom_font_file`),
  sendExternalUserDataReport: () => Fetch.post('external_user_data_report'),
};
export default AcademiesApi;
